import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import InternetChecking from "../../Student/Reusablecomponents/Network";
// import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import CopyRight from "../../Student/Reusablecomponents/Copyright";
import { AssessmentTypeNo } from "../../ReusableComponents/CommonApis";

const Assessments = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [Load, SetLoad] = useState(false);
    const [AssessValues, setAssessValues] = useState([]);
    const USYear = useSelector((state) => state.SelecYearData.SYear);

    // Used to fetch all assessment types from API (Sodhana, Sadhana, Samagra)
    const GetAssessmentTypes = async () => {
        SetLoad((prev) => !prev);
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_BASE_URL +
                `/NCLAdmin/GetAssessmentTypeForAssessment?AcademicYear=${USYear?.value}`,
                {
                    headers: { XApiKey: process.env.REACT_APP_XApiKey },
                }
            );
            setAssessValues(response.data);
            SetLoad((prev) => !prev);
        } catch (error) {
            console.error("Error fetching School data:", error);
            return [];
        }
    };
    useEffect(() => {
        GetAssessmentTypes();
    }, [USYear]);

    //Used to navigate to WeeklyTests screen for selected assessment type
    const WeeklyAssessments = (row) => {
        navigate("/NCLAdmin/Assessments/WeeklyTests", {
            state: {
                SelecTYpe: row.assessmentType,
                AssessmentId: row.assessmentId,
                AssessmentName: row.assessmentTypeName,
                 AssessmentTypeNo:row.assessmentTypeNo
            }
        });
    };

    // Columns for DataTable
    // const Columns = [
    //     {
    //         name: "Assessment Type",
    //         cell: (row) => {
    //             const typeMap = {
    //                 1: "Sodhana",
    //                 2: "Sadhana",
    //                 3: "Samagra",
    //             };
    //             return typeMap[row.assessmentType] || row.assessmentType;
    //         },
    //         sortable: true,
    //     },
    //     {
    //         name: "Assessment Name",
    //         selector: "assessmentTypeName",
    //         sortable: true,
    //         cell: (row) => (
    //             <div
    //                 onClick={() => WeeklyAssessments(row)}
    //                 className="LinkStyles"
    //             >
    //                 {row.assessmentTypeName}
    //             </div>
    //         ),
    //     },
    //     { name: "Institutes", selector: "institutes", sortable: true },
    // ];
    const AssessmenTesTypes = [
        { title: "SODHANA", type: 1 },
        { title: "SADHANA", type: 2 },
        { title: "SAMAGRA", type: 3 },
    ];
    // const renderRows = (type) => {
    //     const filtered = AssessValues?.filter((item) => item.assessmentType === type);
    //     if (!filtered?.length) {
    //         return (
    //             <tr> <td colSpan={2} > ** No data available ** </td> </tr>
    //         );
    //     }

    //     return filtered?.map((item) => (
    //         <tr onClick={() => WeeklyAssessments(item)} className="LinkStyles"
    //         key={item.assessmentType}>
    //             <td>{item?.assessmentTypeName}</td>
    //             <td>{item?.institutes}</td>
    //         </tr>
    //     ));
    // };

    const renderRows = (type) => {
        const filtered = AssessValues?.filter((item) => item.assessmentType === type);

        if (!filtered?.length) {
            return (
                <tr><td colSpan={2}>** No data available **</td></tr>
            );
        }

        return filtered.map((item,index) => (
            <tr
                onClick={() => WeeklyAssessments(item)}
                className="LinkStyles"
                key={item.assessmentId}
            >
                <td>{item.assessmentTypeName}</td>
                <td>{item.institutes}</td>
            </tr>
        ));
    };
    return (
        <>
            <div className="TeacherBgImage">
                <InternetChecking />
                <div className="MainHeading">
                    Assessments  ({USYear?.display})
                </div>
                <div className="NCLDataTable mt-2">
                    <table className="Data-Table" style={{ tableLayout: "fixed" }}>
                    </table>
                </div>
                {/* {AssessValues && AssessmenTesTypes.map(({ title, type }) => (
                    <div className="Card NCLDataTable mt-2">
                        <div className="SubHeading mt-1 mb-2">{title}</div>
                        <table className="Data-Table" style={{ tableLayout: "fixed" }}>
                            <tbody>
                                {renderRows(type)}
                            </tbody>
                        </table>
                    </div>
                ))} */}
                <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
                    {AssessValues &&
                        AssessmenTesTypes.map(({ title, type }) => (
                            <div
                                key={type}
                                className="Card NCLDataTable"
                                style={{
                                    flex: 1,              
                                    minWidth: "300px"
                                }}
                            >
                                <table className="Data-Table" style={{ tableLayout: "fixed" }}>
                                    <thead>
                                        <tr>
                                            {/* <th>S.No</th> */}
                                            <th>{title}</th>
                                            <th>Institutes</th>
                                        </tr>
                                    </thead>

                                    <tbody>{renderRows(type)}</tbody>
                                </table>
                            </div>
                        ))}
                </div>

                {/* <div className="Card NCLDataTable mt-2" style={{ padding: "20px" }}>
                    <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
                        {AssessValues &&
                            AssessmenTesTypes.map(({ title, type }) => (
                                <div
                                    key={type}
                                    style={{
                                        flex: 1,
                                        minWidth: "300px"
                                    }}
                                >
                                    <table className="Data-Table" style={{ tableLayout: "fixed", width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th>{title}</th>
                                                <th>Institutes</th>
                                            </tr>
                                        </thead>

                                        <tbody>{renderRows(type)}</tbody>
                                    </table>
                                </div>
                            ))}
                    </div>
                </div> */}


                {/* <CopyRight /> */}
            </div>
        </>
    )
}
export default Assessments;
